<template>
    <div class="pageTableUsers">

      <ListTableHeader :route="elementRoute" :text-header="$t('Urządzenia')"
                       :permission-param="`edit_device`"
                       :text-button="`+ ` + $t('Dodaj urządzenie')"></ListTableHeader>

      <div class="row">
            <div class="col-12">
              <perfect-scrollbar class="scroll-table">
                <b-table
                  striped
                  :items="elementsFiltered"
                  :fields="fields"
                  :per-page="perPage"
                  :current-page="currentPage"
                  class="custom table-users"
                  :tbody-tr-class="rowClass">
                  <template slot="top-row" class="sub-header">
                    <td :key="key" v-for="(field, key) in fields">
                      <template v-if="[0,1,2,3,4].indexOf(key) !== -1">
                        <div class="d-flex">
                          <div class="input-group sm custom search ">
                            <input type="text" v-model="filters[field.key]"
                                   :placeholder="$t('Wyszukaj')"
                                   class="form-control sm custom">
                          </div>
                        </div>
                      </template>
                    </td>
                  </template>

                  <template slot="statusReadable" slot-scope="scope">
                    <p class="border-status custom "
                       :class="scope.item.status === 1 ? 'border-success' : 'border-danger'">
                      {{$t(scope.item.statusReadable)}}</p>
                  </template>

                  <template slot="actions" slot-scope="scope">
                    <div class="wrap-ico-btn d-flex justify-content-center align-items-center  ">
                      <PreviewButton :route="`admin.device.preview`"
                                     :item-id="scope.item.id">
                      </PreviewButton>
                      <EditButton :route="elementRoute"
                                  :permission-param="`edit_device`"
                                  :item-id="scope.item.id">
                      </EditButton>
                      <DeleteButton :item-id="scope.item.id" :return-param="`deleteDevice`"
                                    :item-title="scope.item.unit.unitId"
                                    :permission-param="`delete_device`">
                      </DeleteButton>
                    </div>
                  </template>
                  <template slot="functions" slot-scope="scope">
                    <div class="wrap-ico-btn d-flex justify-content-center align-items-center">
                      <b-dropdown class="custom" toggle-tag="a" variant="link" >
                        <template slot="text">
                          <span class="icon icon-more"></span>
                        </template>
                        <b-dropdown-item href="#">
                          <b-link>
                            {{ $t('Alerty') }}(todo)
                          </b-link>
                        </b-dropdown-item>
                        <b-dropdown-item href="#">
                          <b-link :to="{name:'admin.administration.unitInputs'}">
                            {{ $t('Komunikaty') }}
                          </b-link>
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                  </template>
                </b-table>
              </perfect-scrollbar>
            </div>
        </div>
        <b-row>
            <b-pagination
                    v-show="totalRows > perPage"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    class=" custom"
            ></b-pagination>

        </b-row>
        <confirmDeleteModal></confirmDeleteModal>
    </div>
</template>

<script>
import confirmDeleteModal from '@/components/Modals/ConfirmDeleteModal'
import { mapActions } from 'vuex'
import nonStandartFilterMixin from '@/mixins/nonStandartFilterMixin'

import EditButton from '@/components/Buttons/EditButton'
import DeleteButton from '@/components/Buttons/DeleteButton'
import PreviewButton from '@/components/Buttons/PreviewButton'
import ListTableHeader from '@/components/Headers/ListTableHeader'

export default {
  name: 'Devices',
  components: {
    confirmDeleteModal,
    EditButton,
    DeleteButton,
    PreviewButton,
    ListTableHeader
  },
  mixins: [nonStandartFilterMixin],
  data () {
    return {
      elementRoute: 'admin.device',
      fields: [
        { key: 'unit.unitId', label: this.$t('ID urządzenia'), sortable: true },
        { key: 'unitType.title', label: this.$t('Rodzaj urządzenia'), sortable: true },
        { key: 'outpost.mainAddress', label: this.$t('Adres placówki'), sortable: true },
        { key: 'company.title', label: this.$t('Nazwa firmy'), sortable: true },
        { key: 'statusReadable', label: this.$t('Status urządzenia'), sortable: true },
        { key: 'firmware', label: this.$t('Firmware'), sortable: true },
        { key: 'lastContact', label: this.$t('Ostatni kontakt'), sortable: true },
        { key: 'actions', label: this.$t('Operacje') },
        { key: 'functions', label: this.$t('Funkcje') }
      ]
    }
  },
  methods: {
    ...mapActions(['getDevices']),
    rowClass (item, type) {
      if (type === 'row-top') {
        return 'sub-header'
      }
      return ''
    }
  },
  computed: {
    queryParams () {
      return this.$route.query
    },
    elements () {
      return this.$store.getters.devices
    }
  },
  created () {
    this.getDevices(this.queryParams)
  }
}
</script>

<style scoped>

</style>
